import { connect } from 'react-redux';
import { orderItemInventorySelector } from '../../../../../../redux/cart/cart.selectors';
import { InventoryOrderItemList as Component } from './inventory-order-item-list';
const selector = (state, ownProps) => {
  const [firstElement] = ownProps.items;
  const isArray = Array.isArray(firstElement);
  const item = isArray ? firstElement[0] : firstElement;
  return {
    inventory: orderItemInventorySelector(state, item)
  };
};
export const InventoryOrderItemList = connect(selector)(Component);